import { action, decorate, observable } from "mobx";

const materialTypes = ['Archived websites', 'Audio', 'Books', 'Datasets', 'Dissertations', 
'Images', 'Legislation / Government publications',  
'Manuscripts', 'Maps', 'Notated music', 'Newspapers', 'Periodicals', 
'Personal narratives', 'Software', 'Video', 'Web pages']
class SearchInput {
    
    constructor() {
        this.value = null;
        this.doTranslate = true;
        this.selectedTypes = [];
        this.dates = null;        
    }
    
    setSelectedTypes(l, options) {
        this.selectedTypes = l.map(i => materialTypes[options.indexOf(i)])
        
    }

}

decorate(SearchInput, {
    value: observable,
    doTranslate: observable,
    selectedTypes: observable,
    dates : observable,
    setSelectedTypes : action.bound
}
);

export {SearchInput, materialTypes};